export default {
    apiKey: "AIzaSyBDAeGsKonAnoj49u0-KFgo78n8_fyn_k4",
    authDomain: "rd-party-apps-46404.firebaseapp.com",
    projectId: "rd-party-apps-46404",
    storageBucket: "rd-party-apps-46404.appspot.com",
    messagingSenderId: "905925775608",
    appId: "1:905925775608:web:60be7e2cd9a74b9df3ab0d",
    measurementId: "G-LFKSL8GP93"
};